import { UsersForm } from "../../components/Forms/";

const NewUsers = () => {
  return <UsersForm />;
};

export default NewUsers;
